import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { DashboardMetrics } from '../../services/api/dashboardService';
import {
  AppstoreOutlined,
  DatabaseOutlined,
  BarChartOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import './DashboardMetricsDisplay.css';

interface DashboardMetricsDisplayProps {
  metrics: DashboardMetrics;
}

export const DashboardMetricsDisplay: React.FC<DashboardMetricsDisplayProps> = ({ metrics }) => {
  const getUtilizationColor = (utilization: number) => {
    if (utilization >= 90) return '#ff4d4f';
    if (utilization >= 70) return '#52c41a';
    return '#faad14';
  };

  const getBottleneckColor = (count: number) => {
    return count > 0 ? '#ff4d4f' : '#52c41a';
  };

  return (
    <div className="dashboard-metrics-display">
      <Card title="Control Overview" className="metrics-card">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Card className="metric-item">
              <Statistic
                title="Total Processes"
                value={metrics.total_processes}
                prefix={<AppstoreOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="metric-item">
              <Statistic
                title="Total Items"
                value={metrics.total_items}
                prefix={<DatabaseOutlined />}
                valueStyle={{ color: '#52c41a' }}
                formatter={(value) => value?.toLocaleString()}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="metric-item">
              <Statistic
                title="Average Utilization"
                value={metrics.average_utilization}
                prefix={<BarChartOutlined />}
                suffix="%"
                precision={1}
                valueStyle={{ color: getUtilizationColor(metrics.average_utilization) }}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Card className="metric-item">
              <Statistic
                title="Bottlenecks"
                value={metrics.bottleneck_count}
                prefix={<ExclamationCircleOutlined />}
                valueStyle={{ color: getBottleneckColor(metrics.bottleneck_count) }}
              />
            </Card>
          </Col>
        </Row>

        {metrics.process_types.length > 0 && (
          <div className="process-types-summary">
            <h4>Active Process Types:</h4>
            <div className="process-types-list">
              {metrics.process_types.map((type, _index) => (
                <span key={type} className="process-type-tag">
                  {type}
                </span>
              ))}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};
